import capitalize from 'lodash/capitalize';
import classnames from 'classnames';
import numeral from 'numeral';
import { Button, Modal } from 'components/common';
import { useResponsiveWidth } from 'libs';

interface SwitchPlatinumSubscriptionProps {
  activePrice: {
    frequency?: string;
    price?: number;
  };
  inactivePrice: {
    frequency?: string;
    price?: number;
    stripe_price?: string;
  };
  onHideModal: () => void;
  onShowSwitchModal: () => void;
  onSwitch: (data: { stripe_price?: string }) => void;
  showSwitchModal: boolean;
}

const SwitchPlatinumSubscription = ({
  activePrice,
  inactivePrice,
  onHideModal,
  onSwitch,
  onShowSwitchModal,
  showSwitchModal,
}: SwitchPlatinumSubscriptionProps) => {
  const { isMinSm } = useResponsiveWidth();
  const inactivePricePrice = `${numeral(inactivePrice.price! / 100).format('$0,0')} / ${capitalize(
    inactivePrice.frequency
  )}`;

  return (
    <div data-testid="subscriptions-switch-subscription-card">
      <Modal onHide={onHideModal} show={showSwitchModal} centered>
        <div className="p-3">
          <h4 className="fw-bold" data-testid="subscriptions-switch-subscription-modal-title">
            Confirm switch
          </h4>
          <div className="my-4" data-testid="subscriptions-switch-subscription-modal-plan">
            Your new plan will be billed at <strong>{inactivePricePrice}.</strong>
          </div>
          <div className="my-4">
            <strong>This action cannot be reversed</strong>.
          </div>
          <div className={classnames({ 'd-inline-block': isMinSm, 'col-md-12 mb-2': !isMinSm })}>
            <Button
              onClick={() => onSwitch({ stripe_price: inactivePrice.stripe_price })}
              testId="subscriptions-switch-subscription-modal-confirm-button"
              text="bold"
              variant="primary-dark"
              width={isMinSm ? 'content' : 'block'}
            >
              Switch subscription
            </Button>
          </div>
          <div className={classnames({ 'd-inline-block ms-2': isMinSm, 'col-md-12': !isMinSm })}>
            <Button onClick={onHideModal} text="bold" variant="border" width={isMinSm ? 'content' : 'block'}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      <div className="card-body">
        <h4 className="fw-bold mb-0">Switch subscription</h4>
        <div className="mb-2">
          <div className="mb-0">
            You are currently on the {capitalize(activePrice.frequency)} plan, but you can switch to the{' '}
            {capitalize(inactivePrice.frequency)} plan.
          </div>
          <div className="mb-0" data-testid="subscriptions-switch-subscription-card-plan">
            Your new plan would be billed at {inactivePricePrice}.<strong> You will be unable to switch back.</strong>
          </div>
          <div>
            {activePrice.frequency === 'monthly'
              ? 'Your plan will be switched immediately, and charges will be prorated.'
              : 'The change will take effect at the end of your current billing period.'}
          </div>
        </div>
        <Button
          onClick={onShowSwitchModal}
          testId="subscriptions-switch-subscription-card-button"
          text="bold"
          variant="primary-dark"
        >
          Switch subscription
        </Button>
      </div>
    </div>
  );
};

export default SwitchPlatinumSubscription;
